import React from 'react';
import { connect } from 'react-redux';

import ViewLayout from '../_ViewLayout';
import { FlocktoryProductContainer } from '../../components';

const OutOfStockView = () => {
  return (
    <div itemScope itemType="http://schema.org/Product">
      <FlocktoryProductContainer>
        <ViewLayout detailsType="subscribePreview" />
      </FlocktoryProductContainer>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(OutOfStockView);
